import React from "react";
import PaginatedView from "../../../components/UI/PaginatedView/PaginatedView";
import { funcionalidades } from "../../../context/AuthContext";
import { apiRoutes } from "../../../hooks/apiClient";

const columns = [
  {
    name: "Sigla",
    selector: "txInaptidao",
    maxWidth: "10%",
    sortable: true,
  },
  {
    name: "Nome",
    selector: "dsInaptidao",
    maxWidth: "50%",
    sortable: true,
  },
  {
    name: "Situação",
    cell: (row) => (row.fgAtivo === "S" ? "Ativo" : "Inativo"),
    selector: "fgAtivo",
    maxWidth: "20%",
    sortable: true,
    center: true,
  },
];

const ConsultaTipoInaptidao = ({ history, match }) => (
  <PaginatedView
    title="Tipo de Inaptidão"
    keyField="sqTipoInaptidao"
    descriptionField="dsInaptidao"
    defaultSearch
    defaultSearchPlaceholder="Digite a sigla"
    queryService={apiRoutes.fiscalizacao.parametrizacao.consultaTipoInaptidao}
    deleteService={apiRoutes.fiscalizacao.parametrizacao.excluiTipoInaptidao}
    editRoute={`${match.url}/form`}
    columns={columns}
    permissionDelete={funcionalidades.tipoInaptidao.deletar}
    permissionInsert={funcionalidades.tipoInaptidao.inserir}
    history={history}
  />
);

export default ConsultaTipoInaptidao;
